import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "80px",
  background: "#FCF9F7",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "24px",
    alignItems: "flex-start",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  maxWidth: "375px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "340px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    gap: "16px",
    maxWidth: "unset",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  maxWidth: "1280px",
  alignItems: "flex-start",
  gap: "56px 40px",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",

  [props.theme.breakpoints.down("lg")]: {
    gap: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "40px",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "64px",
  maxWidth: "64px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "16px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "unset",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "16px" : "24px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 600,
  lineHeight: props.type == "desc" ? "24px" : "36px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.15px" : "unset",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "14px" : "16px",
    lineHeight: props.type == "desc" ? "21px" : "24px",
    letterSpacing: props.type == "desc" ? "unset" : "unset",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
